<template>
  <div class="hub-license">
    <el-form :model="form" label-width="108px" class="gen-form" :rules="rules" ref="form">
      <p class="intro">生成 WirdHouse 服务舱 license.lic。导入后 Hub 将按所选授权版本自动切换单机/服务版；机器绑定（IP/MAC/SN）可选；至少选择一个功能卡片。</p>
      <el-form-item label="授权版本" prop="deploy_mode">
        <el-radio-group v-model="form.deploy_mode">
          <el-radio label="standalone">单机版（本地自管）</el-radio>
          <el-radio label="managed">服务版（WirdAdmin 管理）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input v-model="form.description" maxlength="80" placeholder="授权描述" />
      </el-form-item>
      <el-form-item label="生效时间" prop="issued_time">
        <el-date-picker v-model="form.issued_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="生效时间" />
      </el-form-item>
      <el-form-item label="失效时间" prop="expiry_time">
        <el-date-picker v-model="form.expiry_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="失效时间" />
      </el-form-item>
      <el-form-item label="功能卡片" prop="features">
        <el-checkbox-group v-model="form.features">
          <el-checkbox label="stream">桌面推流</el-checkbox>
          <el-checkbox label="fileshare">文件分享</el-checkbox>
          <el-checkbox label="player">智能播放器</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="IP地址">
        <el-input type="textarea" v-model="form.ip_addr" :rows="2" placeholder="可选，逗号分隔" />
      </el-form-item>
      <el-form-item label="MAC地址">
        <el-input type="textarea" v-model="form.mac" :rows="2" placeholder="可选，逗号分隔" />
      </el-form-item>
      <el-form-item label="SN号码">
        <el-input type="textarea" v-model="form.sn" :rows="2" placeholder="可选，CPU/主板序列号，逗号分隔" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="genLoading" @click="submit">生成并下载 LICENSE</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import licenseApi from "@/api/license";

export default {
  name: "HubLicense",
  data() {
    return {
      genLoading: false,
      form: {
        description: "",
        issued_time: "",
        expiry_time: "",
        deploy_mode: "standalone",
        features: ["stream", "fileshare", "player"],
        ip_addr: "",
        mac: "",
        sn: "",
      },
      rules: {
        description: [{ required: true, message: "请输入描述", trigger: "blur" }],
        issued_time: [{ required: true, message: "请选择生效时间", trigger: "change" }],
        expiry_time: [{ required: true, message: "请选择失效时间", trigger: "change" }],
        deploy_mode: [{ required: true, message: "请选择授权版本", trigger: "change" }],
        features: [{ type: "array", required: true, min: 1, message: "至少选择一个功能", trigger: "change" }],
      },
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate(async (ok) => {
        if (!ok) return;
        this.genLoading = true;
        try {
          const res = await licenseApi.generateHubLicense(this.form);
          if (res && res.status === "success") {
            this.$message.success("已下载 license.lic");
          } else if (res && res.message) {
            this.$message.error(res.message);
          }
        } catch (e) {
          this.$message.error("生成失败");
        } finally {
          this.genLoading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.hub-license { padding: 16px 20px; }
.intro { color: #64748b; font-size: 13px; margin: 0 0 16px; }
.gen-form { max-width: 640px; }
</style>
